import { z } from "zod";
import { PreReviewDocumentSchema } from "../treezor/index.js";

export default {
  params: z.object({
    memberInvitationId: z.string(),
  }),
  response: z.object({
    powerOfAttorneyDocument: PreReviewDocumentSchema.nullable(),
  }),
};
